{
  "en": {
    "item": {
      "deleted": "Deleted Content"
    }
  }
}
